var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "750",
            persistent: "",
            transition: "dialog-bottom-transition"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-toolbar",
                { attrs: { dark: "", color: "primary" } },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", dark: "" },
                      on: { click: _vm.cerrar }
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                  _c("v-toolbar-title", [
                    _vm._v(
                      "\n          Eventos Courier — Orden: " +
                        _vm._s(_vm.despaseguimiento) +
                        "\n        "
                    )
                  ]),
                  _c("v-spacer")
                ],
                1
              ),
              _c(
                "v-card-text",
                { staticClass: "pa-4" },
                [
                  !_vm.events || _vm.events.length === 0
                    ? _c(
                        "div",
                        { staticClass: "text-xs-center py-4" },
                        [
                          _c(
                            "v-icon",
                            { attrs: { large: "", color: "grey lighten-1" } },
                            [_vm._v("inbox")]
                          ),
                          _c("p", { staticClass: "grey--text mt-2" }, [
                            _vm._v(
                              "\n            Sin eventos registrados para esta encomienda.\n          "
                            )
                          ])
                        ],
                        1
                      )
                    : _c(
                        "v-timeline",
                        { attrs: { dense: "" } },
                        _vm._l(_vm.events, function(evento, index) {
                          return _c(
                            "v-timeline-item",
                            {
                              key: index,
                              attrs: {
                                color:
                                  index === 0 ? "primary" : "grey lighten-1",
                                small: ""
                              }
                            },
                            [
                              _c(
                                "v-card",
                                { staticClass: "elevation-1 mb-2" },
                                [
                                  _c(
                                    "v-card-text",
                                    { staticClass: "pa-3" },
                                    [
                                      _c(
                                        "v-layout",
                                        {
                                          attrs: {
                                            row: "",
                                            wrap: "",
                                            "align-center": ""
                                          }
                                        },
                                        [
                                          _c(
                                            "v-flex",
                                            { attrs: { xs12: "", sm8: "" } },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "font-weight-bold body-2"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(evento.status) +
                                                      "\n                    "
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "caption grey--text mt-1"
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      staticStyle: {
                                                        color: "#526da5"
                                                      },
                                                      attrs: { small: "" }
                                                    },
                                                    [_vm._v("location_on")]
                                                  ),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(evento.location) +
                                                      "\n                      "
                                                  ),
                                                  evento.office &&
                                                  evento.office !==
                                                    evento.location
                                                    ? _c(
                                                        "span",
                                                        [
                                                          _vm._v(
                                                            "\n                         · \n                        "
                                                          ),
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticClass:
                                                                "mr-1",
                                                              staticStyle: {
                                                                color: "#526da5"
                                                              },
                                                              attrs: {
                                                                small: ""
                                                              }
                                                            },
                                                            [_vm._v("business")]
                                                          ),
                                                          _vm._v(
                                                            "\n                        " +
                                                              _vm._s(
                                                                evento.office
                                                              ) +
                                                              "\n                      "
                                                          )
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            ]
                                          ),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "text-sm-right",
                                              attrs: { xs12: "", sm4: "" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "caption font-weight-medium"
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "mr-1",
                                                      staticStyle: {
                                                        color: "#526da5"
                                                      },
                                                      attrs: { small: "" }
                                                    },
                                                    [_vm._v("event")]
                                                  ),
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(
                                                        _vm.formatDatetime(
                                                          evento.datetime
                                                        )
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ],
                                                1
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "", color: "primary" },
                      on: { click: _vm.cerrar }
                    },
                    [_vm._v("Cerrar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }